.root {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-1) 0;
}

.tempo {
  display: flex;
  align-items: flex-end;
  gap: var(--tuna-spacing-1);
}

.bpm {
  width: 7rem;
}

.control {
  min-width: 6rem;
}

.wide {
  min-width: 9rem;
}
